import type { InteractionsConfig } from '@wix/thunderbolt-becky-types'

export const assignCompPathToInteractionsConfig = (
	interactionsConfig: InteractionsConfig,
	compIdToTemplateCompPath: Record<string, string>
): InteractionsConfig => {
	return {
		interactions: interactionsConfig.interactions.map((interaction) => ({
			...interaction,
			key: compIdToTemplateCompPath[interaction.key] ?? interaction.key,
			effects: interaction.effects.map((effect) => ({
				...effect,
				...(effect.key && { key: compIdToTemplateCompPath[effect.key] ?? effect.key }),
			})),
		})),
		effects: interactionsConfig.effects,
		...(interactionsConfig.conditions && { conditions: interactionsConfig.conditions }),
	}
}
